const ConfigurableColors: ConfigurableColors = {
    rosso: ['text-[#FF0000]', 'bg-[#FF0000]', 'border-[#FF0000]', 'fill-[#FF0000]'],   // Red
    bianco: ['text-[#FFFFFF]', 'bg-[#FFFFFF]', 'border-[#FFFFFF]', 'fill-[#FFFFFF]'],  // White
    nero: ['text-[#000000]', 'bg-[#000000]', 'border-[#000000]', 'fill-[#000000]'],    // Black
    azzurro: ['text-[#14688E]', 'bg-[#14688E]', 'border-[#14688E]', 'fill-[#14688E]'], // LightBlue
    grigio: ['text-[#E6E6E6]', 'bg-[#E6E6E6]', 'border-[#E6E6E6]', 'fill-[#E6E6E6]'],  // LightGrey
    grigiomedio: ['text-[#505050]', 'bg-[#505050]', 'border-[#505050]', 'fill-[#505050]'],  // MediumGrey
};

interface ConfigurableColors {
    [key: string]: [string, string, string, string];
}

type ColorType = 'text' | 'bg' | 'border' | 'fill';


function configColor(type: ColorType, colorKey: string): string {
    const types: Record<ColorType, number> = {
        text: 0,
        bg: 1,
        border: 2,
        fill: 3,
    };
    const colorArray = ConfigurableColors[colorKey?.toLowerCase()];

    if (colorArray && types.hasOwnProperty(type)) {
        return '' + colorArray[types[type]];
    } else {
        return '';
    }
}

export default configColor;